import React from 'react';
import { Alert, Button, Card, Col, Divider, Form, FormInstance, Input, Row, Space, Switch, Tooltip } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined, QuestionCircleOutlined, SaveOutlined, ThunderboltOutlined } from '@ant-design/icons';
import { TConnectionStatus } from './types';

interface FactusCredentialsTabProps {
  form: FormInstance;
  connectionStatus: TConnectionStatus;
  testingConnection: boolean;
  savingConfig: boolean;
  onTestConnection: () => void;
  onSaveConfig: (values: any) => void;
}

export const FactusCredentialsTab: React.FC<FactusCredentialsTabProps> = ({
  form,
  connectionStatus,
  testingConnection,
  savingConfig,
  onTestConnection,
  onSaveConfig
}) => {
  return (
    <Card size="small" style={{ borderRadius: 8 }}>
      <Form
        form={form}
        layout="vertical"
        onFinish={onSaveConfig}
        initialValues={{
          is_shared_pool: true
        }}
      >
        <Row gutter={16}>
          <Col span={24}>
            <Form.Item
              name="is_shared_pool"
              valuePropName="checked"
              label={
                <Space size={4}>
                  <strong>Modalidad de Bolsa de Folios</strong>
                  <Tooltip title="Activa si esta empresa comparte la bolsa de folios/facturas con otras empresas o con la cuenta matriz de Ryo. Desactiva si tiene su propia bolsa exclusiva.">
                    <QuestionCircleOutlined style={{ color: '#1677ff', cursor: 'pointer' }} />
                  </Tooltip>
                </Space>
              }
            >
              <Switch
                checkedChildren="Bolsa Compartida"
                unCheckedChildren="Bolsa Propia (Individual)"
                defaultChecked
              />
            </Form.Item>
          </Col>
        </Row>

        <Alert
          type="info"
          showIcon
          message="Credenciales de Autenticación Factus API V2"
          description="Ingresa las credenciales OAuth2 de la cuenta de Factus que emitirá los documentos para esta empresa. Si dejas estos campos vacíos, el sistema usará las credenciales maestras por defecto del servidor."
          style={{ marginBottom: 16 }}
        />

        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="client_id"
              label="Client ID (Factus)"
              rules={[{ required: false }]}
            >
              <Input placeholder="Ej. 9cb3f78a-..." />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="client_secret"
              label="Client Secret (Factus)"
              rules={[{ required: false }]}
            >
              <Input.Password placeholder="Client Secret provisto por Factus" />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="username"
              label="Username / Correo Factus"
              rules={[{ required: false }]}
            >
              <Input placeholder="correo@empresa.com" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="password"
              label="Contraseña de la cuenta Factus"
              rules={[{ required: false }]}
            >
              <Input.Password placeholder="Contraseña de Factus" />
            </Form.Item>
          </Col>
        </Row>

        {connectionStatus && (
          <Alert
            type={connectionStatus.success ? 'success' : 'error'}
            showIcon
            icon={connectionStatus.success ? <CheckCircleOutlined /> : <CloseCircleOutlined />}
            message={connectionStatus.message}
            style={{ marginBottom: 16 }}
          />
        )}

        <Divider style={{ margin: '12px 0' }} />

        <Row justify="space-between" align="middle">
          <Col>
            <Button
              icon={<ThunderboltOutlined />}
              onClick={onTestConnection}
              loading={testingConnection}
            >
              Probar Conexión con Factus
            </Button>
          </Col>
          <Col>
            <Button
              type="primary"
              icon={<SaveOutlined />}
              htmlType="submit"
              loading={savingConfig}
            >
              Guardar Credenciales
            </Button>
          </Col>
        </Row>
      </Form>
    </Card>
  );
};
